import React from 'react';
import { PrismicRichText } from "@prismicio/react";
import StyledInfoDialog from './StyledInfoDialog';
import LoadingIndicator from './LoadingIndicator';

import crossBlack from '../assets/icons/cross-black.svg';
import '../assets/scss/dialog.scss';

const ExtraInfoDialog= ({content, onClose, open, state}) => {
    if (state === 'idle' || state === 'loading') return <LoadingIndicator />;

    const descriptions = [];
   
    content.primary_description && content.primary_description.length && (content.primary_description[0].type !== 'paragraph' || (content.primary_description[0].type === 'paragraph' && content.primary_description[0].text)) && descriptions.push(content.primary_description);
    content.secondary_description && content.secondary_description.length && (content.secondary_description[0].type !== 'paragraph' || (content.secondary_description[0].type === 'paragraph' && content.secondary_description[0].text)) && descriptions.push(content.secondary_description);
    content.tertiary_description && content.tertiary_description.length && (content.tertiary_description[0].type !== 'paragraph' || (content.tertiary_description[0].type === 'paragraph' && content.tertiary_description[0].text)) && descriptions.push(content.tertiary_description);

    return (
        <StyledInfoDialog open={open} onClose={onClose}>
            <div className="dialog">
                <div className="dialog__heading">
                    {content.title && (
                        <PrismicRichText field={content.title} />
                    )}

                    <img
                        src={crossBlack}
                        alt="cross"
                        className="dialog__close"
                        onClick={onClose}
                    />
                </div>

                <div className="dialog__content">
                    {descriptions && descriptions.length && descriptions.map((description, index) => (
                        <div key={index} className={`dialog__description dialog__description--${(index + 1).toString()}`}>
                            <PrismicRichText
                                field={description}
                                key={index}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </StyledInfoDialog >
    )
}
export default ExtraInfoDialog;
